// extracted by mini-css-extract-plugin
export var attachment = "_pc-a";
export var emailContainer = "_pc-4";
export var emailContentPaddedContainer = "_pc-b";
export var emailHeader = "_pc-6";
export var emailIframe = "_pc-3";
export var emailInfoIcon = "_pc-9";
export var emailShortenedSummary = "_pc-e";
export var infoDropdown = "_pc-0";
export var infoRowBoundedContent = "_pc-d";
export var internal = "_pc-5";
export var merchant = "_pc-8";
export var messageInputContainer = "_pc-h";
export var normal = "_pc-7";
export var replyCard = "_pc-f";
export var subtleButton = "_pc-1";
export var subtleButtonIconContainer = "_pc-2";
export var toggleViewRepliesButton = "_pc-c";
export var wrappingText = "_pc-g";